import React from 'react';

/**
 * DonutChart SVG puro (sin librerías): recibe segments con {label, value, color}.
 * Segments con value=0 se filtran de la leyenda automáticamente (requisito UX).
 */
export function DonutChart({ segments = [], size = 160, thickness = 24, title }) {
  const visible = segments.filter((s) => (s.value || 0) > 0);
  const total = visible.reduce((acc, s) => acc + s.value, 0);
  const cx = size / 2;
  const cy = size / 2;
  const r = (size - thickness) / 2;
  const c = 2 * Math.PI * r;

  let offset = 0;

  return (
    <div className="flex flex-col items-center gap-4">
      {title && (
        <p className="text-xs text-[#6A736B] uppercase tracking-wider font-semibold self-start">
          {title}
        </p>
      )}
      <div className="flex items-center gap-6 w-full">
        <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`} className="flex-shrink-0" data-testid={`donut-${(title || '').replace(/\s+/g,'-').toLowerCase()}`}>
          {/* Track background para cuando hay 1 solo segmento */}
          <circle cx={cx} cy={cy} r={r} fill="none" stroke="#F3EBE1" strokeWidth={thickness} />
          {total > 0 &&
            visible.map((s) => {
              const len = (s.value / total) * c;
              const dash = `${len} ${c - len}`;
              const el = (
                <circle
                  key={s.label}
                  cx={cx}
                  cy={cy}
                  r={r}
                  fill="none"
                  stroke={s.color}
                  strokeWidth={thickness}
                  strokeDasharray={dash}
                  strokeDashoffset={-offset}
                  transform={`rotate(-90 ${cx} ${cy})`}
                  strokeLinecap="butt"
                />
              );
              offset += len;
              return el;
            })}
          <text x={cx} y={cy - 4} textAnchor="middle" className="fill-[#1A1C18]" style={{ fontSize: 22, fontWeight: 700 }}>
            {total}
          </text>
          <text x={cx} y={cy + 14} textAnchor="middle" className="fill-[#6A736B]" style={{ fontSize: 10 }}>
            total
          </text>
        </svg>
        <ul className="flex-1 space-y-1.5">
          {visible.length === 0 && (
            <li className="text-sm text-[#6A736B] italic">Sin datos aún</li>
          )}
          {visible.map((s) => {
            const pct = total > 0 ? Math.round((s.value / total) * 100) : 0;
            return (
              <li key={s.label} className="flex items-center justify-between text-sm" data-testid={`donut-legend-${s.label}`}>
                <span className="flex items-center gap-2 min-w-0">
                  <span className="w-2.5 h-2.5 rounded-full flex-shrink-0" style={{ backgroundColor: s.color }} />
                  <span className="text-[#1A1C18] truncate">{s.label}</span>
                </span>
                <span className="flex items-center gap-2 text-xs">
                  <span className="text-[#6A736B]">{pct}%</span>
                  <span className="font-bold text-[#1A1C18] tabular-nums w-6 text-right">{s.value}</span>
                </span>
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
}
